export interface InvoiceThemeResponse {
    Id: number;
    Name: string;
    DisplayImage: string;
    BackgroundImage: string;
    TableHeaderColor: string;
    TableHeaderTextColor: string;
    MainTextColor: string;
}

export class InvoiceTheme {
    id: number;
    name: string;
    displayImage: string;
    backgroundImage: string;
    tableHeaderColor: string;
    tableHeaderTextColor: string;
    mainTextColor: string;

    constructor(fromServer: InvoiceThemeResponse = null) {
        if (fromServer != null) {
            this.id = fromServer.Id;
            this.name = fromServer.Name;
            this.displayImage = fromServer.DisplayImage;
            this.backgroundImage = fromServer.BackgroundImage;
            this.tableHeaderColor = fromServer.TableHeaderColor;
            this.tableHeaderTextColor = fromServer.TableHeaderTextColor;
            this.mainTextColor = fromServer.MainTextColor;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/InvoiceTheme.ts